import { spacesIcon } from '@/assets/icons';
import { AssetIcon, type AssetIconProps } from './AssetIcon';

export type SpacesIconProps = Omit<AssetIconProps, 'src' | 'alt'>;

export function SpacesIcon({ size = 20, className, ...props }: SpacesIconProps) {
  return <AssetIcon src={spacesIcon} size={size} className={className} {...props} />;
}
